import { useUnit } from 'effector-react'
import * as React from 'react'

import { $gift, giftCategoriesList } from './model'
import { $giftsCategories } from '../../giftsCategories/list/model'

export const useGift = () => {
  const gift = useUnit($gift)
  const giftCategories = useUnit($giftsCategories).map((category) => ({
    id: category.id,
    name: category.name,
  }))

  React.useEffect(() => {
    giftCategoriesList()
  }, [])

  return { gift, giftCategories }
}
